import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import CalendarToggler from '../components/calendarToggler'
import CalendarFilter from '../components/calendarFilter'
import { useTheme } from '@emotion/react'

const CalendarHeader = ({
  calendarValue,
  setCalendarValue,
  calendarFilter,
  setCalendarFilter,
  handleClick,
  apiFilter,
  setApiFilter,
}) => {
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.up('md'))
  const sm = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 50,
      }}
    >
      <CalendarToggler
        setCalendarValue={setCalendarValue}
        calendarValue={calendarValue}
        handleClick={handleClick}
        md={md}
        sm={sm}
      />
      {md && (
        <CalendarFilter
          filters={calendarFilter}
          setFilters={setCalendarFilter}
          apiFilter={apiFilter}
          setApiFilter={setApiFilter}
        />
      )}
    </Box>
  )
}

export default CalendarHeader
